<template>
  <div class="header width-full ls-flex-col-center" id="scrollable">
    <div class="max-width ispc">
      <div class="flex align-center flex-between mauto" style="padding: 0.5rem 0;" >
        <div class="pointer" @click="$router.push({path:'/'})" style="width: 25%;">
          <div class="flex align-center">
            <img src="../assets/logo.png" alt="" style="width: 88px;height: 59px;">
          </div>
        </div>
        <div class="flex flex-between align-center">
          <div v-for="item in tabList" :key="item.id" @click="selectTab(item)" :class="{'active': selectedTab === item.id}" class="tab-item">{{ item.name }}
          </div>
          <div class="lan" @click="changeLanguage(getlanguage)">
            <img src="../assets/language.png" alt="" style="width: 16px;height: 16px;">
            <div>{{ getlanguage == 'zh' ? 'EN' : 'CH'}}</div>
          </div>

   
        </div>
        
      </div>
      
    </div>
    <div class="ismobile">
      <div class="mobile flex flex-between align-center" style="position: relative;"> 
        <div class="flex align-center" @click="$router.push({path:'/'})"> 
          <img src="../assets/logo.png" alt="" style="width: 60px;height: 40px;">
        </div>
        <div class="flex">
          <div class="lan" @click="changeLanguage(getlanguage)">
            <img src="../assets/language.png" alt="" style="width: 16px;height: 16px;">
            <div>{{ getlanguage == 'zh' ? 'EN' : 'CH'}}</div>
          </div>
          <img src="../assets/more.png" alt="" style="margin-left: 10px;width: 22px;height: 22px;" @click="toggleMobileMenu" >
        </div>
      </div>

        <div v-if="isMobileMenuVisible" class="overlay" @click="toggleMobileMenu"></div>
        <div v-if="isMobileMenuVisible" class="mobileShow" >
          <div class="mobile flex flex-between align-center" style="position: relative;"> 
            <div class="flex align-center" @click="$router.push({path:'/'});isMobileMenuVisible=false"> 
              <img src="../assets/logo.png" alt="" style="width: 60px;height: 40px;">
            </div>
            <div class="flex">
              <div class="lan" @click="changeLanguage(getlanguage)">
                <img src="../assets/language.png" alt="" style="width: 16px;height: 16px;">
                <div>{{ getlanguage == 'zh' ? 'EN' : 'CH'}}</div>
              </div>
              <img src="../assets/more.png" alt="" style="margin-left: 10px;width: 22px;height: 22px;" @click="toggleMobileMenu" >
            </div>
          </div>
          <div class="width-full">
            <div class="bg-white" style="padding: 10px 20px 20px 20px;font-size: 14px;">
              <div class="flex flex-between align-center b-b-1">
                <div @click="selectedTab = 1;$router.push({path:'/'});isMobileMenuVisible=false" :class="selectedTab == 1 ? 'color1 font-bold' : ''" style="padding-bottom: 10px;font-size: 15px;">{{ $t('home') }}</div>
                <i v-if="selectedTab == 1" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div>
              <div class="flex flex-between align-center" :class="selectedTab == 2 ? '' : 'b-b-1'">
                <div @click="selectedTab = 2;mobileTab = ''" :class="selectedTab == 2 ? 'color1 font-bold' : ''" style="padding: 10px 0;font-size: 15px;">{{ $t('about') }} </div>
                <i v-if="selectedTab == 2" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div>
              <div class="tab2Show b-b-1" v-if="selectedTab == 2">
                <div class="" style="padding-bottom: 10px;">
                  <div @click="jumpAbout('hover1',1)" :class="mobileTab == 1 ? 'color1' : ''" style="padding-top: 10px;font-size: 13px;">·{{ $t('about1') }}</div>
                  <div @click="jumpAbout('hover2',2)" :class="mobileTab == 2 ? 'color1' : ''" style="padding-top: 10px;font-size: 13px;">·{{ $t('about2') }}</div>
                  <div @click="jumpAbout('hover3',3)" :class="mobileTab == 3 ? 'color1' : ''" style="padding-top: 10px;font-size: 13px;">·{{ $t('about3') }}</div>
                  <div @click="jumpAbout('hover4',4)" :class="mobileTab == 4 ? 'color1' : ''" style="padding-top: 10px;font-size: 13px;"> ·{{ $t('about4') }}</div>
                </div>
              </div>


              <div class="flex flex-between align-center b-b-1">
                <div @click="selectedTab = 3;$router.push({path:'/product'});isMobileMenuVisible=false" :class="selectedTab == 3 ? 'color1 font-bold' : ''" style="padding: 10px 0;font-size: 15px;">{{ $t('product') }} </div>
                <i v-if="selectedTab == 3" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div>




              <div class="flex flex-between align-center b-b-1">
                <div @click="selectedTab = 4;$router.push({path:'/use'});isMobileMenuVisible=false" :class="selectedTab == 4 ? 'color1 font-bold' : ''" style="padding: 10px 0;font-size: 15px;">{{ $t('use') }} </div>
                <i v-if="selectedTab == 4" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div>
              
              <div class="flex flex-between align-center b-b-1">
                <div @click="selectedTab = 5;$router.push({path:'/news'});isMobileMenuVisible=false;" :class="selectedTab == 5 ? 'color1 font-bold' : ''" style="padding: 10px 0;font-size: 15px;">{{ $t('news') }} </div>
                <i v-if="selectedTab == 5" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div>



              <div class="flex flex-between align-center ">
                <div @click="selectedTab = 6;$router.push({path:'/contact'});isMobileMenuVisible=false" :class="selectedTab == 6 ? 'color1 font-bold' : ''"  style="padding: 10px 0;font-size: 15px;">{{ $t('contact') }}</div>
                <i v-if="selectedTab == 6" class="el-icon-minus"></i>
                <i v-else class="el-icon-plus"></i>
              </div>
              
            </div>
          </div>
        </div>
      
    </div>
  </div>
  
</template>
   
<script>
import { EventBus } from '../utils/eventBus'
import { index,aboutus,shop,newcenterindex } from "../api/home";
import { mapGetters,mapActions } from 'vuex';
export default {
	data() {
		return { 
      tabList:[
        {id:1,name:this.$t('home'),path:'home'},
        {id:2,name:this.$t('about'),path:'about'},
        {id:3,name:this.$t('product'),path:'product'},
        {id:4,name:this.$t('use'),path:'use'},
        {id:5,name:this.$t('news'),path:'news'},
        {id:6,name:this.$t('contact'),path:'contact'},

      ],
      selectedTab: '',
      isMobileMenuVisible: false,
      info:'',
      mobileTab:'',
		}
	},
  created(){
    this.getInfo()

  },
  watch: {
    '$route': 'setSelectedTab'
  },
  computed:{
    ...mapGetters(['getlanguage','getUserInfo']),
  },
  methods: {
    ...mapActions(['changelanguageValue']),
    changeLanguage(languageValue){
      console.log(languageValue)
      if(languageValue == 'zh'){
        this.$i18n.locale = 'en'
        this.changelanguageValue('en')
      }else{
        this.$i18n.locale = 'zh'
        this.changelanguageValue('zh')
      }
      window.location.reload()
      // this.hireList = [{id:1,name: this.$t('fullMember')},{id:2,name:this.$t('timeMember')},{id:3,name:this.$t('contractorMember')},]
      // this.init()
    },
    getInfo(){
      index({}).then((res) => {
        if (res.code == 1) {
          this.info = res.data
        } 
      });
    },
    setSelectedTab() {
      const path = this.$route.path.split('/')[1];
      if (path == 'productclassFy' || path == 'productDtl') {
        this.selectedTab = 3; 
      }else if (path == 'useDtl') {
        this.selectedTab = 4; 
      }else if (path == 'newsDtl') {
        this.selectedTab = 5; 
      }else{
        const selected = this.tabList.find(tab => tab.path === path);
        this.selectedTab = selected ? selected.id : 1;
      }
    },
    selectTab(item) {
      this.selectedTab = item.id; 
      this.$router.push({ path: item.path == 'home' ? '/' : `/${item.path}` });
      
    },
    toggleMobileMenu() {
      this.isMobileMenuVisible = !this.isMobileMenuVisible;
    },
    jumpAbout(ids,mobileTab){
      this.isMobileMenuVisible = false
      this.mobileTab = mobileTab
      this.$router.push({ path: '/about'});
      setTimeout(()=>{
        EventBus.$emit('scrollTo', ids); 
      },1500)

    },
  },
}
</script>

<style scoped lang="scss">
.header{
  position: sticky;
  top: 0;
  z-index: 1000;
  background: linear-gradient(to right, #5CAAFC, #0A79E5) !important;
}
.tab-item {
  cursor: pointer;
  margin: 0 30px;
  color: #FFFFFF;
  opacity: 0.8;
  font-size: 16px;
  position: relative;
}

.tab-item.active {
  font-weight: bold;
  opacity: 1;
  font-size: 18px;
}
.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: -6px;
  left: 50%;            
  transform: translateX(-50%); 
  width: 26px;    
  height: 2px;
  background-color: #FFFFFF;
}

.lan{
  display: flex;
  align-items: center;
  color: #FFFFFF;
  font-size: 15px;
  padding-left: 15px;
  cursor: pointer;
  img{
    padding-right: 9px;
  }
}

.ismobile{
  width: 100%;

}
.mobile {
  padding: 0.3rem 20px;
  background: linear-gradient(to right, #5CAAFC, #0A79E5) !important;

  img {
    width: 24px;
    height: 24px;
  }
}

.mobileShow {
  position: absolute;
  top: 20px;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  flex-direction: column;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 1);
  z-index: 999;
  display: block;
}




@media (max-width: 1200px) {
  .header{
    background: none;
  }
  
  .ispc{
    display: none;
  }
  .mobileShow{
    position: absolute;
    top: 0;
    left: 0;
  }
  .lan{
    font-size: 13px;
    margin-right: 8px;
    img{
      padding-right: 5px;
    }
  }
  
}
@media (min-width: 1201px) {
  .ismobile {
    display: none; 
  }
}
</style>